import { IOtpSubdomain, initialState } from './model';
import * as Actions from './actions';
import { produce } from 'immer';
import { ENetworkRequestStatus } from 'services/BackendApi/types/Generic';

const otpReducer = (
  state: IOtpSubdomain = initialState,
  action: Actions.OtpActions
) => {
  switch (action.type) {
    case Actions.SET_OTP_EMAIL:
      return produce(state, draftState => {
        draftState.form.email = action.email;
        return draftState;
      });

    case Actions.REQUEST_OTP_EMAIL_REQUEST:
      return produce(state, draftState => {
        draftState.requests.sendEmail.request = ENetworkRequestStatus.PENDING;
        draftState.requests.sendEmail.errors = null;
        draftState.requests.sendEmail.statusCode = null;
        return draftState;
      });

    case Actions.REQUEST_OTP_EMAIL_SUCCESS:
      return produce(state, draftState => {
        draftState.requests.sendEmail.request = ENetworkRequestStatus.SUCCESS;
        draftState.requests.sendEmail.statusCode = action.statusCode;
        draftState.requests.sendEmail.errors = null;
        return draftState;
      });

    case Actions.REQUEST_OTP_EMAIL_FAILURE:
      return produce(state, draftState => {
        draftState.requests.sendEmail.request = ENetworkRequestStatus.ERROR;
        draftState.requests.sendEmail.errors = action.errors;
        return draftState;
      });

    case Actions.VERIFY_OTP_EMAIL_REQUEST:
      return produce(state, draftState => {
        draftState.requests.verifyOtp.request = ENetworkRequestStatus.PENDING;
        draftState.requests.verifyOtp.errors = null;
        draftState.requests.verifyOtp.statusCode = null;
        return draftState;
      });

    case Actions.VERIFY_OTP_EMAIL_SUCCESS:
      return produce(state, draftState => {
        draftState.requests.verifyOtp.request = ENetworkRequestStatus.SUCCESS;
        draftState.requests.verifyOtp.statusCode = action.statusCode;
        draftState.requests.verifyOtp.errors = null;
        return draftState;
      });

    case Actions.VERIFY_OTP_EMAIL_FAILURE:
      return produce(state, draftState => {
        draftState.requests.verifyOtp.request = ENetworkRequestStatus.ERROR;
        draftState.requests.verifyOtp.errors = action.errors;
        return draftState;
      });

    case Actions.SET_RESEND_TIMER:
      return produce(state, draftState => {
        draftState.resendTimer = action.time;
        draftState.form.otp = '';
        draftState.requests.verifyOtp = initialState.requests.verifyOtp;
        return draftState;
      });

    case Actions.SET_OTP_CODE:
      return produce(state, draftState => {
        draftState.form.otp = action.otp;
        draftState.requests.verifyOtp.errors = null; // Reset to remove the error message
        return draftState;
      });

    case Actions.RESET_OTP_SUBDOMAIN:
      return produce(state, draftState => {
        draftState = initialState;
        return draftState;
      });

    default:
      return state;
  }
};

export default otpReducer;